export default __webpack_public_path__ + "static/media/slime.3a5fd77a.png";